import { base64Encode } from '@finect/front-utils/base64';

export const articleWithSafeHTML = article => ({
  ...article,
  body: {
    ...article.body,
    text: base64Encode(article.body.text)
  }
});
